module.exports = {"wsUrl":"wss://nsai.com.co/api","httpUrl":"https://nsai.com.co"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 405
// module chunks = 0